import { t } from '@lingui/macro';
import styled from 'styled-components/macro';

import { Link, ParagraphMd, Title } from '@olist/design-system';
import { tokens } from '@olist/design-system-tokens';
import { Box, Flex } from '@olist/united';

import { Container } from 'components';
import { NotFound } from 'images';
import { BASE_URL } from 'utils/urls';

const NotFoundImage = styled.img`
  margin-bottom: ${tokens.spacing[700]};
`;

const NotFoundTitle = styled(Title)`
  margin-bottom: ${tokens.spacing[400]};
`;

const NotFoundPage = () => {
  return (
    <Container>
      <Box mt="15%" textAlign="center">
        <Flex
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
          maxWidth="650px"
          mx="auto"
        >
          <NotFoundImage src={NotFound} alt="Página não encontrada" />
          <NotFoundTitle>{t`Oops! Page not found`}</NotFoundTitle>
          <ParagraphMd>
            {t`Make sure the address you are looking for is correct or return to the `}
            <br />
            <Link href={BASE_URL} type="inline">{t`start page`}</Link>
          </ParagraphMd>
        </Flex>
      </Box>
    </Container>
  );
};

export default NotFoundPage;
